import { motion, useAnimation } from "framer-motion";
import { Button } from "@/components/ui/button";
import { useIsMobile } from "@/hooks/use-mobile";
import { useTranslation } from 'react-i18next';

export const HeroSection = () => {
  const { t } = useTranslation();
  const imageUrl = "https://images.unsplash.com/photo-1464938050520-ef2270bb8ce8?auto=format&fit=crop&w=2000&q=80&brightness=150";
  const isMobile = useIsMobile();

  return (
    <motion.section
      className="relative xs:h-[500px] md:h-[600px] lg:h-[700px] xl:h-[800px] flex items-center justify-center overflow-hidden"
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      transition={{ duration: 0.5 }}
    >
      <div
        className="absolute inset-0 bg-cover bg-center z-0 transition-opacity duration-500"
        style={{
          backgroundImage: `url("${imageUrl}")`,
          filter: 'brightness(0.75)'
        }}
      />
      <div className="absolute inset-0 bg-black/20 z-[1]"></div>
      <div className="relative z-10 text-center text-white space-y-6 md:space-y-8 lg:space-y-12 px-4 -mt-10 md:-mt-16 lg:-mt-20" style={{ textShadow: '0 2px 12px rgba(0,0,0,0.55)' }}>
        <h1 className="xs:text-3xl md:text-5xl lg:text-6xl font-bold tracking-tight">
          <motion.span
            className="inline-block"
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.6, delay: 0 }}
          >
            {t('hero.tagline')}
          </motion.span>
          <br className="xs:inline md:hidden" />
          <motion.span
            className="inline-block"
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.6, delay: 0.2 }}
          >
            {t('hero.tagline2')}
          </motion.span>
        </h1>
        <div className="space-y-4 md:space-y-6 flex flex-col items-center">
          <motion.p
            className="text-[0.7rem] md:text-lg lg:text-xl font-medium tracking-wide fade-in backdrop-blur-sm bg-white/10 py-2 px-3 md:px-4 rounded-lg whitespace-normal sm:whitespace-nowrap"
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.6, delay: 0.3 }}
          >
            {t('hero.catchcopy')}
          </motion.p>
          <motion.div
            className="xs:text-2xl md:text-3xl lg:text-4xl font-medium tracking-wide fade-in delay-100 backdrop-blur-sm bg-white/10 py-2 px-4 md:py-3 md:px-6 rounded-lg"
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.6, delay: 0.4 }}
          >
            <span className="inline-block text-white">PLANNING</span>
            <span className="text-red-500 font-extrabold inline-block xs:text-3xl md:text-4xl lg:text-5xl" style={{ fontFamily: "'Noto Serif JP', serif", fontWeight: 900 }}>J</span>
            <span className="inline-block text-white">OY</span>
            <span className="block md:inline-block text-white">{t('hero.company_suffix')}</span>
          </motion.div>
        </div>
      </div>
    </motion.section>
  );
};
